import { ReactNode } from 'react';
import { IconArrowLeft } from '@rossum/ui/icons/tabler';
import {
  Button,
  Divider,
  Stack,
  SvgIcon,
  Typography,
} from '@rossum/ui/material';
import { useIntl } from '../../ComponentsContext';

const COMPONENT_WIDTH = 352;

type FilterComponentWrapperProps = {
  filterKey: string;
  name: string;
  onSubmit: () => void;
  isSubmitDisabled: boolean;
  maxWidth?: number;
  children: ReactNode;
  onBackClick?: () => void;
  onClose: () => void;
  dataCy?: string;
};

export const FilterComponentWrapper = ({
  filterKey,
  name,
  onSubmit,
  onBackClick,
  onClose,
  isSubmitDisabled,
  maxWidth = COMPONENT_WIDTH,
  children,
  dataCy,
}: FilterComponentWrapperProps) => {
  const intl = useIntl();

  return (
    <Stack
      p={2}
      alignItems="flex-start"
      spacing={2}
      sx={{
        width: 'auto',
        minWidth: COMPONENT_WIDTH,
        maxWidth,
      }}
      data-cy={dataCy}
    >
      {onBackClick && (
        <Button
          variant="text"
          size="small"
          color="inherit"
          startIcon={
            <SvgIcon fontSize="large">
              <IconArrowLeft />
            </SvgIcon>
          }
          onClick={() => onBackClick()}
          data-cy="filter-back-button"
        >
          {intl.formatMessage({ id: 'containers.filtering.buttons.back' })}
        </Button>
      )}
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', textWrap: 'nowrap' }}
        >
          {name}
        </Typography>
      </Stack>
      {children}
      <Stack width="100%" gap={2}>
        <Divider />
        <Stack flexDirection="row" justifyContent="space-between" width="100%">
          <Stack
            flexDirection="row"
            justifyContent="flex-end"
            width="100%"
            gap={2}
          >
            <Button
              color="secondary"
              variant="outlined"
              onClick={onClose}
              data-cy={`filter-menu-${filterKey}-cancel-button`}
            >
              {intl.formatMessage({
                id: 'containers.filtering.buttons.cancel',
              })}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={onSubmit}
              disabled={isSubmitDisabled}
              data-cy={`filter-menu-${filterKey}-apply-button`}
            >
              {intl.formatMessage({ id: 'containers.filtering.buttons.apply' })}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
